module.exports = "pegasus_template/assets/blocks/header-4-tech.png";